import { FormProvider } from "react-hook-form";
import TailwindSideModal from "../../../components/commonModal/TailwindSideModal";
import TailwindBottomButtonView from "../../../components/mainBottomButtonView/TailwindBottomButtonView";
import CommonSplitContainer from "../../../components/ui/layout/CommonSplitContainer/CommonSplitContainer";
import SupplierRegisterFields from "../shared/components/SupplierRegisterFields";
import { useSupplierEditViewModel } from "./hooks/useSupplierEditViewModel";
import { SupplierEditModalProps } from "./types/supplierEditView.types";

/**
 * Tailwind rebuild of the legacy `SupplierEditModal`
 * (src/screens/supplier/supplierEdit/SupplierEditModal.tsx), following the
 * Lovable prototype's `/lca-suppliers` edit drawer — same shell as
 * `lcaProduct`'s `ProductEditModal`: `TailwindSideModal` +
 * `CommonSplitContainer` + `TailwindBottomButtonView`. Same external props
 * as the legacy modal, so it's a drop-in swap behind
 * `ENABLE_LCA_SUPPLIER_UI_REDESIGN` in `SupplierList.tsx`.
 */
const SupplierEditModal = ({
  visibleModal,
  closeModal,
  onSuccessEdit,
  supplier
}: SupplierEditModalProps) => {
  const vm = useSupplierEditViewModel({ closeModal, onSuccessEdit, supplier });

  return (
    <TailwindSideModal
      open={visibleModal}
      onOpenChange={open => {
        if (!open) vm.onCancel();
      }}
      eyebrow="Suppliers"
      title="Edit supplier"
      titleClassName="tw-font-display"
    >
      <FormProvider {...vm.methods}>
        <CommonSplitContainer
          currentHeight={0.9}
          overflowX="hidden"
          topChild={
            <div className="tw-bg-muted/20 tw-p-6">
              <SupplierRegisterFields
                control={vm.methods.control}
                country={vm.country}
                onCountryChange={vm.onCountryChange}
                isSupplierAsUser={vm.isSupplierAsUser}
                onIsSupplierAsUserChange={vm.onIsSupplierAsUserChange}
              />
            </div>
          }
          bottomChild={
            <TailwindBottomButtonView
              cancelButtonStatus
              saveButtonStatus
              saveTitle="Save changes"
              saveDisable={!vm.canSave}
              saveLoading={vm.isSaving}
              buttonSize="lg"
              cancelButton={vm.onCancel}
              saveButton={vm.onSave}
            />
          }
        />
      </FormProvider>
    </TailwindSideModal>
  );
};

export default SupplierEditModal;
